import { FC } from "react";
import { AppPage } from "shared-ts-ui-app-page";
import { Box, Card, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SentryUserFeedbackForm } from "shared-ts-sentry";
import { createLazyRoute } from "@tanstack/react-router";

export const UserFeedbackPage: FC = () => {
  const { t } = useTranslation("shared-ts-sentry");

  return (
    <AppPage
      $key={"UserFeedback"}
      name={t("Feedback")}
      mainPaneProps={{ scrollableContentVertically: true }}
      mainPane={
        <Box>
          <Container maxWidth={"md"}>
            <Card sx={{p: 2}}>
              <SentryUserFeedbackForm />
            </Card>
          </Container>
        </Box>
      }
    />
  );
};

export const UserFeedbackPageRoute = createLazyRoute("/user-feedback")({
  component: UserFeedbackPage,
});
